import { Reveal } from "./motion-helpers";
import { WHATSAPP_URL, WHATSAPP_DISPLAY } from "./constants";
import { MessageCircle, Store, Handshake, Sparkles } from "lucide-react";

const CATEGORIES = [
  {
    icon: Sparkles,
    label: "First Sip / Founder's Batch",
    body: "Be first to taste the launch batch. Straight from the founders.",
    msg: "Hi DUNC, I'd love to try the First Sip / Founder's Batch.",
  },
  {
    icon: Store,
    label: "Retail & Distribution",
    body: "Café, restaurant, or store owner? Let's talk stocking DUNC.",
    msg: "Hi DUNC — I'd like to explore stocking / distributing DUNC.",
  },
  {
    icon: Handshake,
    label: "Partnerships",
    body: "Collaborations, events, gifting, or something else on your mind.",
    msg: "Hi DUNC — I'd like to explore a partnership.",
  },
  {
    icon: MessageCircle,
    label: "General Enquiries",
    body: "Anything else? Say hi. We read everything.",
    msg: "Hi DUNC — I have a question.",
  },
];

export const Contact = () => (
  <section
    id="contact"
    className="relative z-10 py-32 md:py-40 px-6 scroll-mt-20"
    data-testid="contact-section"
  >
    <div className="mx-auto max-w-6xl">
      <Reveal>
        <p className="mb-8 text-xs uppercase tracking-[0.4em] text-[#D9A441]">
          Contact
        </p>
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold leading-[1.02] text-[#F5EFE6] max-w-3xl">
          Talk to <span className="text-[#D9A441]">DUNC.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-[#CFC6BC]">
          For now, WhatsApp is the fastest way to reach us — pick the option that
          sounds most like you.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
        {CATEGORIES.map((c, i) => {
          const Icon = c.icon;
          return (
            <Reveal key={c.label} delay={i * 0.06}>
              <a
                href={WHATSAPP_URL(c.msg)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`contact-${c.label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
                data-analytics="contact-whatsapp"
                className="group flex items-start gap-5 rounded-2xl border border-white/8 bg-white/[0.02] p-6 md:p-7 transition-colors hover:border-[#D9A441]/40 hover:bg-white/[0.04]"
              >
                <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full border border-white/12 text-[#D9A441]">
                  <Icon className="h-5 w-5" />
                </span>
                <div>
                  <h3 className="font-display text-lg md:text-xl font-bold text-[#F5EFE6]">
                    {c.label}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#CFC6BC]">
                    {c.body}
                  </p>
                  <span className="mt-4 inline-block text-[11px] uppercase tracking-[0.28em] text-[#F5EFE6] transition-colors group-hover:text-[#D9A441]">
                    WhatsApp · {WHATSAPP_DISPLAY}
                  </span>
                </div>
              </a>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Contact;
